import React, { useState } from "react";
import "./Testimonials.css";
import { motion, AnimatePresence } from "framer-motion";

import user1 from "../assets/NewImg.png";
import user2 from "../assets/NewImg2.png";
import user3 from "../assets/NewImg3.png";
import user4 from "../assets/NewImg4.png";

const testimonials = [
  {
    course: "Python Django Course!",
    stars: "★★★★★",
    feedback:
      "I am proud to say that after a few months of taking this course… I learned so many things in web development & this course helped me freshen up on my web development skills and land a job at IT company. I strongly recommend Codex Future to all those who are willing to build a career in Python!",
    name: "Anjalee Jaiswal",
    img: user1,
  },
  {
    course: "Data Analytics Course",
    stars: "★★★★★",
    feedback:
      "I recently completed the Data Analysis course, and I'm impressed with the depth of content and hands-on experience provided. The course covered statistical analysis, data visualization, and machine learning concepts. They take special efforts to make sure your doubts are cleared.",
    name: "Dimple Bhatia",
    img: user2,
  },
  {
    course: "Data Analytics Course",
    stars: "★★★★★",
    feedback:
      "Unlock your coding potential at Codex Future! From their dynamic instructors to hands-on projects, every session sparks creativity and deepens your tech skills. It's where learning feels like crafting future innovations. Dive in and see your coding dreams take flight!",
    name: "Jayanth Akshay",
    img: user3,
  },
  {
    course: "Full Stack Development",
    stars: "★★★★★",
    feedback:
      "The best place to learn coding and grow your technical skills. Mentors are very supportive and help in understanding each topic deeply. Codex Future helped me build real-world projects and boosted my confidence for placements.",
    name: "Rahul Sharma",
    img: user4,
  },
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const handleNext = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setDirection(-1);
    setIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const visibleTestimonials = [];
  for (let i = 0; i < 3; i++) {
    visibleTestimonials.push(testimonials[(index + i) % testimonials.length]);
  }

  const slideVariants = {
    hidden: (direction) => ({
      opacity: 0,
      x: direction > 0 ? 100 : -100,
    }),
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
    exit: (direction) => ({
      opacity: 0,
      x: direction > 0 ? -100 : 100,
      transition: { duration: 0.5, ease: "easeIn" },
    }),
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <p className="subtitle">Our Testimonials</p>
        <h2 className="title">
          What Students Think And Say About Codex Future
        </h2>

        <div className="arrows">
          <span className="arrow" onClick={handlePrev}>
            &#8592;
          </span>
          <span className="arrow" onClick={handleNext}>
            &#8594;
          </span>
        </div>

        <div className="testimonial-wrapper">
          <AnimatePresence mode="popLayout" custom={direction}>
            <motion.div
              key={index}
              className="testimonial-cards"
              variants={slideVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              custom={direction}
            >
              {visibleTestimonials.map((item, i) => (
                <div className="testimonial-card" key={i}>
                  <h4 className="course-name">{item.course}</h4>
                  <div className="stars">{item.stars}</div>
                  <p className="feedback">“ {item.feedback} ”</p>
                  <div className="user-info">
                    <img src={item.img} alt={item.name} />
                    <h5>{item.name}</h5>
                  </div>
                </div>
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
